import React, { useRef } from 'react';
import { StarIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
function StarRating() {
  return <div className="flex gap-1 mb-4" aria-label="5 out of 5 stars" data-id="element-254">
      <StarIcon size={16} className="text-[#c9a84c] fill-[#c9a84c]" data-id="element-255" />
      <StarIcon size={16} className="text-[#c9a84c] fill-[#c9a84c]" data-id="element-256" />
      <StarIcon size={16} className="text-[#c9a84c] fill-[#c9a84c]" data-id="element-257" />
      <StarIcon size={16} className="text-[#c9a84c] fill-[#c9a84c]" data-id="element-258" />
      <StarIcon size={16} className="text-[#c9a84c] fill-[#c9a84c]" data-id="element-259" />
    </div>;
}
export function Testimonials() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  return <section className="w-full bg-[#141414] py-20 md:py-28 px-4" data-id="element-260">
      <div className="max-w-6xl mx-auto" data-id="element-261">
        {/* Header */}
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-262">
          <p className="text-[#c41e3a] font-semibold tracking-[0.25em] uppercase text-sm mb-3" style={{
          fontFamily: 'Oswald, sans-serif'
        }} data-id="element-263">
            Client Reviews
          </p>
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-4" style={{
          fontFamily: 'Oswald, sans-serif'
        }} data-id="element-264">
            WHAT THEY'RE SAYING
          </h2>
          <div className="section-divider w-24 mx-auto" data-id="element-265" />
        </motion.div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-266">
          {/* Testimonial 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-[#1c1c1c] border border-[#2a2a2a] rounded-lg p-7 flex flex-col" data-id="element-267">
            <StarRating data-id="element-268" />
            <blockquote className="text-gray-300 text-base leading-relaxed flex-1 mb-6 italic" data-id="element-269">
              "Best barbershop in Hialeah. Jonathan and his team are
              professionals. My son has been going for 2 years and always leaves
              looking fresh."
            </blockquote>
            <div className="flex items-center gap-3 pt-4 border-t border-[#2a2a2a]" data-id="element-270">
              <div className="w-10 h-10 rounded-full bg-[#c41e3a]/20 border border-[#c41e3a]/30 flex items-center justify-center text-[#c41e3a] font-bold text-sm" style={{
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-271">
                HC
              </div>
              <div data-id="element-272">
                <p className="text-white font-semibold text-sm" style={{
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-273">
                  Happy Client
                </p>
                <p className="text-gray-500 text-xs" data-id="element-274">Verified Review</p>
              </div>
            </div>
          </motion.div>

          {/* Testimonial 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-[#1c1c1c] border border-[#c41e3a]/40 rounded-lg p-7 flex flex-col relative overflow-hidden" data-id="element-275">
            {/* Highlight accent */}
            <div className="absolute top-0 left-0 right-0 h-0.5 bg-[#c41e3a]" aria-hidden="true" data-id="element-276" />
            <StarRating data-id="element-277" />
            <blockquote className="text-gray-300 text-base leading-relaxed flex-1 mb-6 italic" data-id="element-278">
              "Walk-ins always welcome and they never make you wait too long.
              Clean shop, great vibes, best fade in the area."
            </blockquote>
            <div className="flex items-center gap-3 pt-4 border-t border-[#2a2a2a]" data-id="element-279">
              <div className="w-10 h-10 rounded-full bg-[#c41e3a]/20 border border-[#c41e3a]/30 flex items-center justify-center text-[#c41e3a] font-bold text-sm" style={{
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-280">
                RC
              </div>
              <div data-id="element-281">
                <p className="text-white font-semibold text-sm" style={{
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-282">
                  Regular Client
                </p>
                <p className="text-gray-500 text-xs" data-id="element-283">Verified Review</p>
              </div>
            </div>
          </motion.div>

          {/* Testimonial 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="bg-[#1c1c1c] border border-[#2a2a2a] rounded-lg p-7 flex flex-col" data-id="element-284">
            <StarRating data-id="element-285" />
            <blockquote className="text-gray-300 text-base leading-relaxed flex-1 mb-6 italic" data-id="element-286">
              "The attention to detail is unmatched. I won't go anywhere else.
              This is the only place I trust with my hair."
            </blockquote>
            <div className="flex items-center gap-3 pt-4 border-t border-[#2a2a2a]" data-id="element-287">
              <div className="w-10 h-10 rounded-full bg-[#c41e3a]/20 border border-[#c41e3a]/30 flex items-center justify-center text-[#c41e3a] font-bold text-sm" style={{
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-288">
                LC
              </div>
              <div data-id="element-289">
                <p className="text-white font-semibold text-sm" style={{
                fontFamily: 'Oswald, sans-serif'
              }} data-id="element-290">
                  Loyal Customer
                </p>
                <p className="text-gray-500 text-xs" data-id="element-291">Verified Review</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}